import { Injectable } from '@angular/core';
import { FormType } from '../models/form.model';
import { RendererFormsRepository } from '../repositories/renderer-forms.repository';

@Injectable({ providedIn: 'root' })
export class RendererFormsQuery {
  constructor(private rendererFormsRepository: RendererFormsRepository) {}

  getSectionNumber(id: string): string {
    const activeForm = this.rendererFormsRepository.getActive();
    if (
      activeForm.type === FormType.Questionnaire ||
      activeForm.type === FormType.FollowUpQuestions ||
      activeForm.type === FormType.ProjektparterBudget
    ) {
      return;
    }

    const hideSections = this.rendererFormsRepository.getHideSections();
    const visibleSections = activeForm.structure.order.filter(
      (o) => !hideSections?.includes(o),
    );
    const indexOfSection = visibleSections.indexOf(id);
    return indexOfSection === -1 ? undefined : `${indexOfSection + 1}. `;
  }

  selectReadOnly() {
    return this.rendererFormsRepository.readonly$;
  }

  getReadOnly() {
    return this.rendererFormsRepository.getReadonly();
  }
  getIsLoading() {
    return this.rendererFormsRepository.getLoading();
  }
}
